// ── Row filters & shared option lists ────────────────────────────────────────────
// Date / search / category filters used by the tables AND their print buttons,
// so what is printed always matches what the screen showed.

function filterByDate(dateStr, filter) {
  if (!dateStr || !filter || filter.mode === 'all') return true;
  const d = new Date(dateStr);
  const now = new Date();
  if (filter.mode === 'daily') return d.toDateString() === now.toDateString();
  if (filter.mode === 'weekly') {
    const start = new Date(now); start.setDate(now.getDate() - now.getDay()); start.setHours(0,0,0,0);
    return d >= start;
  }
  if (filter.mode === 'monthly') return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
  if (filter.mode === 'yearly') return d.getFullYear() === now.getFullYear();
  if (filter.mode === 'custom') {
    if (filter.from && d < new Date(filter.from)) return false;
    if (filter.to) { const to = new Date(filter.to); to.setHours(23,59,59,999); if (d > to) return false; }
    return true;
  }
  return true;
}

// Human-readable label for an active date filter (used by print reports so the
// printed period matches the filter the user selected in the UI).
function dateFilterLabel(filter, t) {
  if (!filter || filter.mode === 'all') return t('allTime');
  if (filter.mode === 'custom') {
    if (filter.from || filter.to) return `${filter.from || '…'} – ${filter.to || '…'}`;
    return t('filterCustom');
  }
  const keyMap = { daily: 'filterDaily', weekly: 'filterWeekly', monthly: 'filterMonthly', yearly: 'filterYearly' };
  return keyMap[filter.mode] ? t(keyMap[filter.mode]) : t('allTime');
}

// Party search used by the Customers/Suppliers lists (mirrors the UI filter exactly).
function matchPartySearch(p, search) {
  if (!search) return true;
  const q = search.toLowerCase();
  return (p.name || '').toLowerCase().includes(q) || (!!p.phone && p.phone.includes(search));
}

// Cash Book rows as shown on screen: date + category + search filters.
// Shared by the table and the print button so both always agree.
function filterCashEntries(entries, dateFilter, categoryFilter, searchQuery) {
  return (entries || []).filter(c => {
    if (c.is_deleted) return false;
    if (!filterByDate(c.date, dateFilter)) return false;
    if (categoryFilter && categoryFilter !== 'all' && c.category !== categoryFilter) return false;
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      if (!(c.description || '').toLowerCase().includes(q) && !(c.category || '').toLowerCase().includes(q)) return false;
    }
    return true;
  });
}

const computeRunningBalances = (entries) => {
  if (!entries || entries.length === 0) return [];
  const sortedAsc = [...entries].sort((a, b) => {
    const dateComp = (a.date || '').localeCompare(b.date || '');
    if (dateComp !== 0) return dateComp;
    const timeComp = (a.time || '').localeCompare(b.time || '');
    if (timeComp !== 0) return timeComp;
    return (a.created_at || '').localeCompare(b.created_at || '');
  });

  let running = 0;
  const map = new Map();
  sortedAsc.forEach(e => {
    const amt = parseFloat(e.amount || 0);
    if (e.entry_type === 'GIVE') {
      running += amt;
    } else {
      running -= amt;
    }
    map.set(e.id || e, running);
  });

  return entries.map(e => ({
    ...e,
    runningBalance: map.get(e.id || e) ?? 0
  }));
};

const PARTY_BANK_OPTIONS = [
  'HBL',
  'UBL',
  'Meezan Bank',
  'Bank Alfalah',
  'MCB Bank',
  'Allied Bank',
  'Standard Chartered',
  'National Bank of Pakistan',
  'Bank of Punjab',
  'Habib Metropolitan',
  'Other',
];

const STANDARD_BANK_OPTIONS = PARTY_BANK_OPTIONS.filter(bank => bank !== 'Other');

export {
  filterByDate, dateFilterLabel, matchPartySearch, filterCashEntries,
  computeRunningBalances, PARTY_BANK_OPTIONS, STANDARD_BANK_OPTIONS,
};
